var productCardMarkup = `<div class="swym-wishlist-grid {{Swym API Endpoint}}">
		{{#products}} 
	<a href="{{du}}"aria-label="{{dt}}" data-lid="{{ lid }}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
		<div class="swym-title swym-title-1">
			{{dt}}
		</div></button>
		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
			{{variantinfo}}
		</div>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{cu}}{{pr}}
			</div>
        </div>
		<button id="swym-custom-add-toCartBtn" data-state-cart=""data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn hide swym-button swym-button-1 swym-is-button swym-is-button">
			{{#isInCart}}ADD TO BASKET{{/isInCart}}{{^isInCart}}ADD TO BASKET{{/isInCart}}
		</button>
		<button id="NotifyMeBtn" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn hide swym-button swym-button-1 swym-is-button swym-is-button">
			Notify Me
		</button>
        
      
    </a> 
       {{/products}}
	</div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function checkAvailable(pdName) {
  var productUrlAll = document.querySelectorAll(`.swym-wishlist-item`);
  for (var i = 0; i < productUrlAll.length; i++) {
    var productUrl = productUrlAll[i].getAttribute("href");
    const urlObj = new URL(productUrl);
    const pathSegments = urlObj.pathname.split("/");
    const productHandle = pathSegments[2];
    // ${productHandle}
    fetch(`/products/${productHandle}.js`)
      .then((response) => response.json())
      .then((product) => {
        const prvariants = product.variants;
        for (var vari = 0; vari < prvariants.length; vari++) {
          const isAvailable = prvariants[vari].available; // Returns true or false
          const variID = prvariants[vari].id;
          const variTitle = prvariants[vari].name;

          if (isAvailable == true) {
            document
              .querySelector(
                `#swym-custom-add-toCartBtn[data-variant-id="${variID}"]`
              )
              ?.classList.remove("hide");
          } else if (isAvailable == false) {
            var selectorBtn = document.querySelector(
              `#NotifyMeBtn[data-variant-id="${variID}"]`
            );
            var klaviyoBtn = `<div class='klaviyo-product-container' id='klaviyo-data-handle-${productHandle}' data-klaviyo-handle='${productHandle}'>
                                    <div class="klaviyo-button-container"> </div>
                                </div>`;
            selectorBtn?.classList.remove("hide");
            selectorBtn?.insertAdjacentHTML("afterend", klaviyoBtn);

            selectorBtn?.addEventListener("click", function (event) {
              event.preventDefault();

              var klaviyoPopUp = document.querySelector("#klaviyo-bis-modal");
              klaviyoPopUp.classList.remove("hide");
              klaviyoPopUp.querySelector(
                ".modal-title"
              ).innerText = `${variTitle}`;
              klaviyoPopUp.querySelector("#product").value = `${variID}`;

            });
          }
        }
      });

  } // End for loop

  // Klaviyo PopUp Close Function
  $("#klaviyo-bis-modal").on("click", function (event) {
    const klaviyoFormM = document.querySelector("#klaviyo-bis-modal form");
    const successTextM = document.querySelector(
      "#klaviyo-bis-modal #completed_message"
    );
    if (
      event.target === this ||
      $(event.target).is(".klaviyo-bis-close, a.klaviyo-bis-close")
    ) {
      $(this).addClass("hide");
      successTextM.classList.add("hide");
      klaviyoFormM.classList.remove("hide");
    }
  });
} // End checkAvailable function

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    if (products.length) {
      var totalProduct = document.querySelector(".wishlist-pd_length span");
      products.length == 1
        ? (totalProduct.innerText = "1 Product")
        : (totalProduct.innerText = `${products.length} Products`);
    }

    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    var formattedWishlistedProducts = products.map(function (p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
      return p;
    });

    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });

    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
      checkAvailable();
      shareAbleLinkEvent(swat);
    } else {
    }
  });
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  document
    .querySelector("#cart_info #cart-sidebar")
    .classList.add("pd-from-sfl");
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = "Added to Basket";
      e.target.setAttribute("data-state-cart", "swym-added");

      $(".cart-window-bg").removeClass("window-hide");
      $(".cart-nosto-window").removeClass("window-hide");
      $("html, body").addClass("cart-open");

      window.shopping_cart_type == "sidebar"
        ? roar.updateCartSidebar(c, !0)
        : roar.updateCart(c, !0);
    },
    function (e) {
    }
  );
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
    // "sidebar" == window.shopping_cart_type ? roar.updateCartSidebar(t, !0) : roar.updateCart(t, !0);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

let swatVar = "";
function shareAbleLinkEvent(swat) {
  document.querySelectorAll(".share-buttons-item").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();

      /*let customerEmailElement = document.querySelector('#wishlist-items-container');
			if (customerEmailElement) {
				var customerEmail = customerEmailElement.getAttribute("data-customer-email");
				// You can use the customerEmail variable as needed
			}*/

      let params = {
        toEmailId: "", // To Email
        fromName: "Daals", // From Name
        lid: document
          .querySelector(".swym-wishlist-grid .swym-wishlist-item")
          .getAttribute("data-lid"),
        cprops: {},
        platformShareUrlTemplate: "",
        platform: this.getAttribute("data-id"),
        note: "",
        shareUrl: "",
      };

      if (!params.lid) {
        console.error("List ID is missing or invalid.");
        return;
      }
      params.shareUrl = generateUrl(swat, params.lid);

      const onSuccess = function (response) {
      };
      const onError = function (error) {
        console.error("There was an error sharing to the platform", error);
      };

      switch (params.platform) {
        case "facebook":
          params.platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${params.shareUrl}`;
          params.note = "Check out this article!";
          break;
        case "twitter":
          params.platformShareUrlTemplate = `https://twitter.com/share?url=${params.shareUrl}`;
          params.note = "Check out this article on Twitter!";
          break;
        case "pinterest":
          params.platformShareUrlTemplate = `https://pinterest.com/pin/create/button/?url=${params.shareUrl}`;
          params.note = "Check out this article on pinterest!";
          break;
        case "mail":
          params.platformShareUrlTemplate = `${params.shareUrl}`;
          params.note = "Check out this article on mail!";
          break;
        case "whatsapp":
          params.platformShareUrlTemplate = `https://api.whatsapp.com/send?text=${encodeURIComponent(
            params.shareUrl
          )}`;
          params.note = "Check out this article on whatsapp!";
          break;
        case "fb-messenger":
          // params.platformShareUrlTemplate = `fb-messenger://share/?link=${params.shareUrl}`;
          params.platformShareUrlTemplate = `https://m.me/?link=${encodeURIComponent(
            params.shareUrl
          )}`;
          params.note = "Check out this article on messenger!";
          break;
        case "fb-mobile-messenger":
          params.platformShareUrlTemplate = `fb-messenger://share/?link=${params.shareUrl}`;
          params.note = "Check out this article on messenger!";
          break;
        default:
          console.error("Unsupported platform: " + params.platform);
          return;
      }

      shareThrough(swat, params, onSuccess, onError);
    });
  });
}

function shareThrough(swat, params, onSuccess, onError) {
  if (params.platform == "mail") {
    swatVar = swat;
    openPopUp();
  } else {
    swat.shareListSocial(
      params.lid,
      params.fromName,
      params.platformShareUrlTemplate,
      params.platform,
      params.note,
      onError
    );
  }
}

function generateUrlOld(swat, lid) {
  return new Promise((resolve, reject) => {
    let onSuccess = (link, lid) => {
      resolve({ tag: "success", link: link });
    };

    let onError = (error) => {
      reject({ tag: "error", error: error });
    };

    swat.generateSharedListURL(lid, onSuccess, onError);
  })
    .then((result) => {
      if (result.tag === "success") {
        return result.link;
      } else {
        return false;
      }
    })
    .catch((error) => {
      return false;
    });
}

function generateUrl(swat, lid) {
  return `${window.location}hkey=${lid}&lid=${lid}&utm_source=swym-Wishlist&utm_medium=shared-wishlist&utm_campaign=${lid}`;
}

function openPopUp() {
  document.getElementById("emailInputForm").classList.add("show");
  document.querySelector(".form-email_Send #email").value = "";
  document.getElementById("overlay").classList.add("show");
}

function hidePopup() {
  document.getElementById("emailInputForm").classList.remove("show");
  document.getElementById("overlay").classList.remove("show");
}

function sendEmail() {
  // let emailInput = document.getElementById('email-input');
  let enteredEmail = document.querySelector(".form-email_Send #email").value;
  if (!enteredEmail) {
    alert("Please provide your desired email");
    return false;
  }
  hidePopup();

  const onSuccess = function (response) {
    alert("Successfully sent the wishlist contents via Email");
  };
  const onError = function (error) {
    console.error("There was an error sharing to the platform", error);
  };
  swatVar.sendListViaEmail(
    {
      toEmailId: enteredEmail,
      fromName: "Daals",
      note: "Check out this article on mail!",
      lid: document
        .querySelector(".swym-wishlist-grid .swym-wishlist-item")
        .getAttribute("data-lid"),
      cprops: {},
    },
    onSuccess,
    onError
  );
}

document.querySelector(".form-email_Send").addEventListener("submit", (e) => {
  sendEmail();
});



